import { space } from "styled-system";
import styled from "@emotion/styled";

export const Spacer = styled.div(space);
